export default {"src":"/_next/static/media/bank-applepay.50da0e58.svg","height":24,"width":57,"blurWidth":0,"blurHeight":0};